/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:23:26
 * @Description:
 */
export { default as home } from "./home.vue";
